import React from 'react';
import './AlternateTimeDisclaimer.component.css';

export default class AlternateTimeDisclaimer extends React.Component {
    render() {
        return (
            <div className="alternate-time-container">
                <div className="alternate-time-text-container">
                    * Appointment requests not responded to, or confirmed outside of the requested times,
                     may be subject to additional fees to include ramp storage, trailer detention, 
                     or redelivery fees, based on your specific agreement with Schneider. Any questions can be 
                    directed to your customer service representative.
                </div>
            </div>
        );
    }
}